import { useTranslation } from "react-i18next";

import { Avatar, IconButton, MenuItem } from "@mui/material";

import MenuWithArrow from "./MenuWithArrow";
import useMenuState from "hooks/useMenuState";
import useHandleLanguage from "hooks/useHandleLanguage";
import { BASE_PATH, LOCALES_MAP } from "constants/globals";
import { LocaleTypes } from "types";

const LocaleSwitcher = () => {
  const { i18n } = useTranslation();
  const [anchorEl, handleClick, handleClose] = useMenuState();

  const [envLocales, langChange] = useHandleLanguage();

  return (
    <>
      <IconButton onClick={handleClick} size="small" sx={{ mx: "7px" }}>
        <Avatar
          sx={{ width: 24, height: 24 }}
          src={`${BASE_PATH && `/${BASE_PATH}`}/images/flags/Country=${LOCALES_MAP[i18n.language as LocaleTypes].flag}.svg`}
        />
      </IconButton>
      <MenuWithArrow anchorEl={anchorEl} onClose={handleClose} onClick={handleClose}>
        {envLocales.map(locale => {
          return (
            <MenuItem key={locale} onClick={() => langChange(locale)}>
              <Avatar
                sx={{ width: 24, height: 24, mr: "10px" }}
                src={`${BASE_PATH && `/${BASE_PATH}`}/images/flags/Country=${LOCALES_MAP[locale].flag}.svg`}
              />
              {LOCALES_MAP[locale].text}
            </MenuItem>
          );
        })}
      </MenuWithArrow>
    </>
  );
};

export default LocaleSwitcher;
